export default __webpack_public_path__ + "static/media/Shorts.d121e059.png";